import { debounce } from "../utils/performance";
import { ProductCard } from "./product-card-class";
import { initializeProductOption } from "../collections-page/product-item";

const HEADER_DISABLE_ANIMATE_CLASS = 'color-force-normal';
const state = {
  elements: {},
  settings: {},
  parser: new DOMParser,
};

const init = () => (
  cacheElements(),
  attachListeners()
);

const cacheElements = () => {
  const headerContainer = document.querySelector('.section-header');
  const searchbarContainer = headerContainer.querySelector('.searchbar');
  const headerWrapper = headerContainer.querySelector('.header-wrapper');
  state.elements = {
    searchBtn: headerContainer.querySelector('.header__icon--search'),
    headerWrapper,
    backdrop: headerContainer.querySelector('.searchbar__backdrop'),
    searchForm: searchbarContainer.querySelector('.searchbar__form'),
    searchbarContainer,
    searchInput: searchbarContainer.querySelector('.searchbar__input'),
    searchResultsCount: searchbarContainer.querySelector('.searchbar__count span'),
    searchViewAllResultsBtn: searchbarContainer.querySelector('.searchbar__btn-view-all'),
    searchResultsList: searchbarContainer.querySelector('.searchbar__results-body'),
    suggestedProductsContainer:searchbarContainer.querySelector('.predictive--products'),
    suggestedQueriesContainer:searchbarContainer.querySelector('.predictive--queries'),
    searchResultsContainer: searchbarContainer.querySelector('.searchbar__results'),
    searchbarLoader: searchbarContainer.querySelector('.searchbar__loader'),
    stickyHeader: document.querySelector('sticky-header'),
    innerSearchBtn: document.querySelector('.search_btn'),
    resultFooter: document.querySelector('.searchar__results-footer'),
    emptyMessage: document.querySelector('.no-results'), 
    errorMessage: document.querySelector('.searchbar__error'),
    closeIcon: document.querySelector('.search_btn--close'),
  };
  state.settings = JSON.parse(searchbarContainer.dataset.settings || '{}');
};

const attachListeners = () => {
  state.elements.searchBtn.addEventListener('click', openSearchbar);
  state.elements.searchForm.addEventListener('submit', onSumbitSearch);
  state.elements.backdrop.addEventListener('click', closeSearchbar);
  state.elements.closeIcon.addEventListener('click', closeSearchbar);
  state.elements.searchbarContainer.addEventListener('input', onInputSearch);
  state.elements.innerSearchBtn.addEventListener('click', onSumbitSearch)
};

function initProductCards() {
    document.querySelectorAll('.product-item.product-grid-item').forEach((card) => {
        const productCard = new ProductCard(card);
    })
}

const resetRenderedContent = () => {
  state.elements.resultFooter.classList.remove('empty');
  state.elements.suggestedProductsContainer.innerHTML = '';
  state.elements.suggestedQueriesContainer.innerHTML = '';
};

const onInputSearch = debounce(async (e) => {
  const inputValue = e.target.value.trim();
  resetRenderedContent()
  
  if (inputValue.length >= 1) {
    hideLoadingSpinner('remove');
    updateSearchErrorState('remove')
    updateViewAllUrl(inputValue)
    
    Promise.all([
      renderSearchResults(inputValue), 
      getSearchResults(inputValue)
    ])
  } else {
    hideLoadingSpinner('add');
    state.elements.searchResultsContainer.classList.add('hidden')
  };
}, 350);

const hideLoadingSpinner = (action) => {
  let loaderAction = action;
  let resultsAction = "remove";
  if (action == 'remove') {
    resultsAction = 'add'
  } else if (action == 'toggle' && state.elements.searchbarLoader.classList.contains('hidden')) {
    resultsAction = 'add'
  }
  state.elements.searchbarLoader.classList[loaderAction]('hidden');
  state.elements.searchResultsContainer.classList[resultsAction]('hidden')
};

const updateViewAllUrl = (searchKey) => {
  let url;
  if (searchKey) {
    url = `/search?q=${encodeURIComponent(searchKey)}&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide`;
  } else {
    url = "#"
  }
  state.elements.searchViewAllResultsBtn.setAttribute('href', url);
  state.elements.innerSearchBtn.setAttribute('href', url);
};

const updateSearchErrorState = (stateValue) => {
  if (!stateValue) {
    const minimumValue = state.elements.searchInput.value.trim().length >= 1;
    state.elements.errorMessage.classList[`${minimumValue ? 'remove' : 'add'}`]('active')
  } else {
    state.elements.errorMessage.classList[stateValue]('active')
  }
}

const getSearchResults = async (searchTerm) => {
  try {
    const response = await fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
    const strMarkup = await response.text();
    const htmlMarkup = state.parser.parseFromString(strMarkup, 'text/html')
    const predictiveSearchQueries = htmlMarkup.querySelector('.predictive-search--queries');
    if (!predictiveSearchQueries) return;
    state.elements.suggestedQueriesContainer.innerHTML = "";
    state.elements.suggestedQueriesContainer.insertAdjacentElement("beforeend", predictiveSearchQueries);
  } catch (error) {
    console.error(error)
  }
}

const renderSearchResults = async (key) => {
  try {
    let targetUrl = `/search?q=${encodeURIComponent(key)}&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&section_id=main-search`;

    let response = await fetch(targetUrl).then(response => response.text()).then(r => r);
    let htmlMarkup = state.parser.parseFromString(response, 'text/html');
    let scriptTag = htmlMarkup.querySelector('script[data-products]');
    let addProductsToWindow = new Function(scriptTag?.textContent);
    addProductsToWindow();
    let products = Array
      .from(htmlMarkup.querySelectorAll('.product-grid-item'))
      .slice(0, state.settings.search_products_count);
    let isEmpty = htmlMarkup.querySelector('.search-empty');

    state.elements.suggestedProductsContainer.innerHTML = '';
    products.forEach(p => {
      new ProductCard(p)
      state.elements.suggestedProductsContainer.insertAdjacentElement("beforeend", p);
    })

    hideLoadingSpinner('add')
    initProductCards();
    initializeProductOption();
    if (isEmpty) {
      state.elements.resultFooter.classList.add('empty')
      state.elements.emptyMessage.textContent = `Sorry, no results for “${key}”. Please search for a different item.`
    }
  } catch (error) {
    console.error(error)
  }
};

const onSumbitSearch = (e) => {
  e.preventDefault();
  const key = state.elements.searchInput.value.trim()
  if (key.length < 1) {
    updateSearchErrorState()
  } else {
    window.location = `/search?q=${encodeURIComponent(key)}&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide`;
  }
};

const openSearchbar = () => {
  document.body.classList.add('overflow-hidden');
  state.elements.headerWrapper.classList.add(HEADER_DISABLE_ANIMATE_CLASS);
  state.elements.searchbarContainer.classList.add('searchbar--active');
  state.elements.stickyHeader.classList.add('overlay')

  const { searchInput } = state.elements;
  if (searchInput.value && state.settings.clear_content_on_close) {
    searchInput.value = '';
  }

  setTimeout(() => {
    state.elements.searchInput.focus();
  }, 100);
};

const closeSearchbar = () => {
  updateSearchErrorState('remove')

  document.body.classList.remove('overflow-hidden');
  state.elements.searchbarContainer.classList.remove('searchbar--active');
  state.elements.headerWrapper.classList.remove(HEADER_DISABLE_ANIMATE_CLASS);
  state.elements.stickyHeader.classList.remove('overlay')

  if (state.settings.clear_content_on_close) {
    resetRenderedContent();
    state.elements.searchResultsContainer.classList.add('hidden')
  }
};

export default init;
